import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { handleDispatchWeekQuantity, WeekQuantityText } from "./weekQuantity-utils";
export const useWeekQuantity = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((mod) => mod.ModuleName === ModuleNames.WEEK_QUANTITY &&
        mod.Sequence === sequenceNumber &&
        mod.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { WeekQuantityOptions, CenterCards, IsGridLayout, PinToTop, ScreenLG, ScreenMD, ScreenSM, ScreenXS, Visible, GridSpacing, } = moduleConfig;
    // Whether or not the flow is in a draft state: determines if mod config error text is shown.
    const isDraft = store.model.Flow.isDraft;
    // The currently selected quantity.
    // Use non-null assertion operator because this value will be defined if a dayQuantity module is on the flow.
    const storeCartOneTimeOrderPeriod = store.cart.oneTimeOrderPeriod;
    return {
        WeekQuantityOptions,
        CenterCards,
        IsGridLayout,
        PinToTop,
        GridSpacing,
        Visible,
        isDraft,
        ScreenLG,
        ScreenMD,
        ScreenSM,
        ScreenXS,
        storeCartOneTimeOrderPeriod,
        invalidConfigurationText: WeekQuantityText.InvalidConfiguration,
        sliderSettings: SliderSettings(ScreenLG, ScreenMD, ScreenSM, ScreenXS),
        handleDispatchWeekQuantity: handleDispatchWeekQuantity(dispatch)
    };
};
